export const ADMIN_SITE_KEY = 'adminSite';

export const SITE_OPTIONS = [
  { value: 'duanwu', label: '端午版' },
  { value: 'zhongqiu', label: '中秋版' }
];

export function normalizeSite(site) {
  return site === 'zhongqiu' ? 'zhongqiu' : 'duanwu';
}

export function siteLabel(site) {
  const normalized = normalizeSite(site);
  const item = SITE_OPTIONS.find(s => s.value === normalized);
  return item ? item.label : '端午版';
}

export function getAdminSite() {
  const saved = sessionStorage.getItem(ADMIN_SITE_KEY);
  return normalizeSite(saved || 'duanwu');
}

export function setAdminSite(site) {
  sessionStorage.setItem(ADMIN_SITE_KEY, normalizeSite(site));
}
